require('./components/polyfill');

// jQuery Setup
window.$ = require('jquery');
window.jQuery = window.$;	// alias for Bootstrap

require('./components/tooltips');
require('./components/stickyInfo');
let angular = require('angular');
require('angular-inview/angular-inview');
require('./ng-services/api');
require('./ng-services/shared');
require('./ng-services/channel');

import NP_TM from './components/np-tagmanager';
import FormFieldHandle from './components/formInputHandle';
import initAccordions from './components/accordions';
import initModals from './components/modals';
import Swiper, { Navigation,Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

// Google Tag-Manager
window.tag = new NP_TM({
	manualAttachments: (_this) => {
		_this.push('page1');

		let allCheckBoxesAndRadios = Array.prototype.slice.call(document.querySelectorAll(`${_this.config.selectorTrigger} input[type="radio"], ${_this.config.selectorTrigger} input[type="checkbox"]`));
		allCheckBoxesAndRadios.forEach(input => {
			let parent = input.parentNode;
			let event = parent.getAttribute(_this.config.attrEvent);
			if (event) {
				parent.addEventListener('click', ev => {
					if (ev.target !== parent && ev.target !== input && !ev.target.hasAttribute(_this.config.attrEvent)) {
						_this.push(event);
					}
				});
			}
		});
	}
});

const { DateTime } = require('luxon');
const TM = {
	'pageNext1': { 'event': 'weiter_angaben_zum_kredit' },

	'pageNext2': { 'event': 'weiter_angaben_zum_beruf' },
	'page2': { 'event': 'erreicht_angaben_zum_beruf' },
	'pageBack2': { 'event': 'zurueck_angaben_zum_beruf' },

	'pageNext3': { 'event': 'weiter_leistungsauswahl' },
	'page3': { 'event': 'erreicht_leistungsauswahl' },
	'pageBack3': { 'event': 'zurueck_leistungsauswahl' },

	'pageNext4': { 'event': 'weiter_persoenliche_daten' },
	'page4': { 'event': 'erreicht_persoenliche_daten' },
	'pageBack4': { 'event': 'zurueck_persoenliche_daten' },

	'pageNext5': { 'event': 'weiter_bankdaten' },
	'page5': { 'event': 'erreicht_bankdaten' },
	'pageBack5': { 'event': 'zurueck_bankdaten' },

	'pageNext6': { 'event': 'weiter_vvi' },
	'page6': { 'event': 'erreicht_vvi' },
	'pageBack6': { 'event': 'zurueck_vvi' },

	'pageNext7': { 'event': 'weiter_rechtliche_hinweise' },
	'page7': { 'event': 'erreicht_rechtliche_hinweise' },
	'pageBack7': { 'event': 'zurueck_rechtliche_hinweise' },

	'page8': { 'event': 'erreicht_zusammenfassung' },
	'pageBack8': { 'event': 'zurueck_zusammenfassung' },

	'page9': { 'event': 'erreicht_abschluss' },

	'ctaCompletion': { 'event': 'weiter_abschluss_seite' },
};

// Setup form
initAccordions();
initModals();
new FormFieldHandle();

// slider config
let createOverviewSlider = (() => {
	let overviewSliderInstance = false;
	return () => {
		if (!overviewSliderInstance) {
			overviewSliderInstance = true;
			let overviewSlider = new Swiper('.js-overview-slider', {
				slidesPerView: 'auto',
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						allowTouchMove: false,
					},
				},
				on: {
					init: function() {
						let overviewSliderContainer = document.querySelector('.overview-slider');
						let overviewSlides = overviewSliderContainer.querySelectorAll('.swiper-slide');
						let numberOfActiveSlides = 0;
						overviewSlides.forEach(overviewSlide => {
							if (!overviewSlide.classList.contains('hidden')) {
								numberOfActiveSlides++;
							}
						});
						if(numberOfActiveSlides <= 1) {
							overviewSliderContainer.classList.add('disabled');
							this.allowTouchMove = false;
						}
					},
					resize: function() {
						let overviewSliderContainer = document.querySelector('.overview-slider');
						if (overviewSliderContainer.classList.contains('disabled')) {
							this.allowTouchMove = false;
						}
					},
				},
			});
		}
	};
})();
let createPackageSlider = (() => {
	let packageSliderInstance = false;
	return () => {
		if (!packageSliderInstance) {
			packageSliderInstance = true;
			let packageSlider = new Swiper('.js-package-slider', {
				slidesPerView: 'auto',
				initialSlide: 1, // start with second package (Komfort)
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						initialSlide: 0,
						allowTouchMove: true,
					},
					1220: {
						slidesPerView: 'auto',
						allowTouchMove: false,
					},
				},
				on: {
					resize: function() {
						if (window.innerWidth >= 1220) {
							if (this.wrapperEl) {
								let allSlidesWithStyleAttr = Array.prototype.slice.call(this.wrapperEl.querySelectorAll('.swiper-slide[style]'));
								if (allSlidesWithStyleAttr.length > 0) {
									allSlidesWithStyleAttr.forEach(slideWithStyleAttr => slideWithStyleAttr.removeAttribute('style'));
									this.update();
								}
							}
						}
					},
				},
			});
		}
	};
})();

let app = angular.module('npSPA', [ 'angular-inview', 'api', 'shared', 'channel' ]);

app.factory('$tagmanager', function() {
	return {
		push: function(ids) {
			if (typeof(ids) !== 'object') {
				ids = [ ids ];
			}

			if (typeof(dataLayer) !== 'undefined') {
				ids.forEach( id => {
					if (typeof(TM[id]) !== 'undefined') {
						dataLayer.push(TM[id]);
					}
				});
			}

			if (typeof(_mtm) !== 'undefined') {
				ids.forEach( id => {
					if (typeof(TM[id]) !== 'undefined') {
						_mtm.push(TM[id]);
					}
				});
			}
		}
	}
});

// Used constants, for better overview
const JOB_ANGESTELLT	= 0;  // use option values in select for the values
const JOB_BEAMTE		= 2;
const JOB_FREELANCER	= 10;
const JOB_SONSTIGE		= 12;

const STEP1_CREDIT		= 1;
const STEP2_JOB			= 2;
const STEP3_INS			= 3;
const STEP4_PERSONAL	= 4;
const STEP5_BANK		= 5;
const STEP6_VVI			= 6;
const STEP7_LEGAL		= 7;
const STEP8_OVERVIEW	= 8;
const STEP9_COMPLETION	= 9;

const checkCode = code => {
	let expectedLength = 11;

	if (code.length !== expectedLength) {
		return false;
	}

	let contractNumber = code.substr(0, code.length - 3);
	let crossSum = 0;
	for (let i = 0; i < contractNumber.length; ++i) {
		crossSum += parseInt(contractNumber[i]);
	}
	if (crossSum < 10) {  // duplicate number to force two numbers
		crossSum += '' + crossSum;
	}

	let q1 = crossSum.toString()[0];  // 1
	let q2 = crossSum.toString()[1];  // 0
	let quotient = Math.ceil(q2/q1);

	return code === '' + contractNumber + crossSum + quotient;
};

// Main controller, encompassing all other controllers
app.controller('application', ['$timeout', '$http', '$q', 'shared', 'channel', '$tagmanager', function($timeout, $http, $q, shared, channel, $tagmanager) {
	this.data = {
		step: STEP1_CREDIT,
		prevStep: STEP1_CREDIT,	// used for removing the previous class on header
		sending: false,	// for vvi, does not block nextStep
		sendingContract: false, // contract needs to block next step button or user clicks multiple times
		checkingValidity: false,
		checkingCreditSum: false,
		blockStep: [
			undefined,	// Step 0 - non existent
			true,		// Credit information
			true,		// Job information
			true,		// Alternate insurance packages to choose from, or none
			true,		// Personal information
			true,		// Bank data
			true,		// VVI
			true,		// legal notices
			false,		// summary
			false,		// congratulation
		],
		// list for the data to collect via eventCollectFormData
		// If on step 1 we click "Next" button, the current step must send its data here
		collectDataFor: [
			undefined,  // step 0, not used
			'Credit',
			'Job',
			'AddInsurance',
			'Personal',
			'Bank',
			undefined,  // vvi; handled inside this controller
			undefined,  // legal; same for this one
			undefined,
			undefined,
		],
		insPkgPriceQ: undefined,
		vviId: undefined,		  // important for contract VVI files
		error: false,
		insuranceName: {
			'basis': 'Basis-Absicherung',
			'komfort': 'Komfort-Absicherung',
			'premium': 'Premium-Absicherung'
		},
		contractId: undefined,
		maxInsuranceRuntime: null,
		insurancePackagePriceError: undefined,
	};

	this.form = {
		eligibilityCode: typeof(__PREFILL) !== 'undefined' ? __PREFILL?.eligibilityCode?.toString() : undefined,  // entered code
		docsDownloaded: undefined,		// vvi step related
		unbindDiscretion: undefined,	// in case of death, discretion is waived
		collectionData: undefined,		// agreement on collection personal data

		credit: {},
		job: {},
		addInsurance: {},
		addInsuranceCosts: {},    // API call result from this controller
		personal: {},
		bank: {},
	};

	// Template functions, for quicker access to variables
	this.tmpl = {
		blockPrevStep: () => this.data.sendingContract,
		blockNextStep: () => {
			return this.data.blockStep[this.data.step+1];
		},
		blockPackages: () => this.data.checkingCreditSum,
		displaySpinner: () => this.data.checkingValidity || this.data.sendingContract || this.data.sending || this.data.checkingCreditSum,  // "weiter" button
		getStep: () => this.data.step,
		nextStep: async (step) => {
			if (this.data.insurancePackagePriceError !== undefined && this.data.step == STEP3_INS) { return; }

			let currentStep = this.data.step;
			let nextStep = step ? step : this.data.step + 1;

			// abort, or we trigger validation
			if (nextStep === STEP4_PERSONAL && this.data.checkingCreditSum) {
				return;
			}

			//let validInput = await this.checkValidity(currentStep, nextStep);
			$timeout(() => this.data.checkingValidity = true, 0);

			// clicking/touching next button sets focus on the button,
			// but mobile may have visible keyboard that must be collapsed before scrolling, or scroll position is wrong
			await (new Promise(resolve => setTimeout(resolve, 250)));

			channel.notify(`triggerValidationByStep_${ currentStep }`, {}).then(
				async (result) => {
					if (!Array.isArray(result) || !result[0]) {
						$timeout(() => this.data.checkingValidity = false, 250);   // shortly display a spinner as feedback that something was done, this adds to the above await promise
						return;
					}
					$timeout(() => this.data.checkingValidity = false, 0);

					// Sending notification for collecting step data
					let eventType = this.data.collectDataFor[currentStep];  // current step's controller
					if (eventType !== undefined) {
						await channel.notify(`collectFormData${ eventType }`, {});
					}

					// next step is step 3, we need to take data from step 1 and 2 and do package calculation with for step 4
					// step 3 has no blocker, it's just a display of the free insurance
					if (nextStep === STEP3_INS) {
						// CLARMO-216 - we need to calculate the availability of the non-free options and their limits
						let clientBirthday = DateTime.fromFormat(this.form.job.birthday, 'dd.MM.yyyy');
						let clientCurrentAge = -1*clientBirthday.diffNow('years').years * 12;  // years is in fractions
						let maxRuntimeInMonths = Math.ceil( (780-clientCurrentAge) );  // can only insure full months, 3.01 months runtime is 4 months runtime

						this.data.maxInsuranceRuntime = maxRuntimeInMonths < this.form.credit.runtime ? Math.min(maxRuntimeInMonths, this.form.credit.runtime) : false;

						await this.checkCreditSum();
					}

					if (nextStep === STEP6_VVI) {
						return this.getVVI();
					}

					if (nextStep === STEP9_COMPLETION) {
						return this.placeOrder();
					}

					$tagmanager.push(`pageNext${ currentStep }`);
					this.setStep(nextStep);
				}
			);
		},
		prevStep: step => {
			let currentStep = this.data.step;
			let nextStep = step ? step : this.data.step - 1;
			if (nextStep < STEP6_VVI) {
				$timeout(() => this.form.docsDownloaded = undefined, 0);  // reset check or user changes something without reading new VVI
			}
			if (nextStep < STEP7_LEGAL) {
				$timeout(() => {
					this.form.unbindDiscretion = undefined;
					this.form.collectionData = undefined;
				}, 0);
			}

			if (nextStep < STEP1_CREDIT) {
				nextStep = STEP1_CREDIT;
			}

			$tagmanager.push(`pageBack${ currentStep }`);
			this.setStep(nextStep);
		},
		getSelectedPackage: () => this.form.addInsurance.selectedPackage,
		addInsurance: () => !!this.form.addInsurance.selectedPackage,
		addInsuranceName: () => {
			if (!!this.form.addInsurance.selectedPackage) {
				return this.data.insuranceName[this.form.addInsurance.selectedPackage];
			}
		},
		formatSelectedPackagePrice: () => {
			try {
				let format = this.form.addInsurance.packagePrices[this.form.addInsurance.selectedPackage].insurance1Result.premiumTotal.toString().replace('.', ',');
				let parts = format.split(',');
				if (parts.length < 2) {  // if the API returns just "7"
					return format + ',00';
				}
				if (parts[1].length < 2) {  // if the API returns 7,1
					return format + '0';
				}
				return format + ' €';
			} catch (e) {
				return '- €';
			}
		},
		addInsuranceCost: () => {
			try {
				if (!!this.form.addInsurance.selectedPackage) {
					let format = this.form.addInsurance.packagePrices[this.form.addInsurance.selectedPackage].insurance1Result.premiumTotal.toString().replace('.', ',');
					let parts = format.split(',');
					if (parts.length < 2) {  // if the API returns just "7"
						return format + ',00 €';
					}
					if (parts[1].length < 2) {  // if the API returns 7,1
						return format + '0 €';
					}

					return format + ' €';
				}
			} catch (e) {
				//
			}

			return '-';
		},
		insurances: () => this.data.insurances,
		totalCosts: () => {
			let costs = this.tmpl.addInsuranceCost();
			return costs !== '-' ? costs : '0,00 €';
		},
		getInsurancePrices: () => this.data.insPkgPriceQ !== undefined,
		displayPremium: () => this.form.job.jobGroup && this.form.job.jobGroup == JOB_ANGESTELLT,
		downloadVvi: () => {
			let a = document.createElement('a');
				a.setAttribute('href', __downloadVVI.replace('{id}', this.data.vviId));
				a.setAttribute('target', '_blank');
				a.setAttribute('class', 'hidden');
			document.body.appendChild(a);
			a.click();
			a.remove();
		},
		downloadContract: () => {
			let a = document.createElement('a');
				a.setAttribute('href', __downloadContract.replace('{id}', this.data.contractId));
				a.setAttribute('target', '_blank');
				a.setAttribute('class', 'hidden');
			document.body.appendChild(a);
			a.click();
			a.remove();
		},
		getLastAjaxError: () => !!this.data.error ? ( __CONTEXT === 0 ? 'dev-mode: ' + this.data.error : 'Es ist ein Fehler aufgetreten.' ) : false,
		getDeathBenefit: (p1) => {
			try {
				if (typeof(this.form.credit.creditSum) !== 'undefined') {
					return shared.formatAsNumber(
						shared.getDeathBenefit(
							parseFloat(this.form.credit.creditSum.replace(',', '.'))
						)
					);
				}
			} catch (e) {
				//
			}

			return '-';
		},
		getIncidentBonus: () => {
			try {
				if (typeof(this.form.credit.monthlyRate) !== 'undefined') {
					return shared.formatAsNumber(
						shared.getIncidentBonus(
							parseFloat(this.form.credit.monthlyRate.replace(',', '.'))
						)
					);
				}
			} catch (e) {
				//
			}

			return '-';
		},
		getWorkRelatedBenefit: () => {
			try {
				if (typeof(this.form.credit.monthlyRate) !== 'undefined') {
					return shared.formatAsNumber(
						shared.getWorkRelatedBenefit(
							parseFloat(this.form.credit.monthlyRate.replace(',', '.'))
						)
					);
				}
			} catch (e) {
				//
			}
		},
		hideUnemployment: () => {
			return this.form.job.jobGroup !== undefined &&
				(
					(this.form.job.jobGroup == JOB_ANGESTELLT && this.form.job.partTime == 1) ||
					(this.form.job.jobGroup == JOB_FREELANCER && this.form.job.reducedWork == 1) ||
					(this.form.job.jobGroup == JOB_BEAMTE || this.form.job.jobGroup == JOB_SONSTIGE)
				);

			/*typeof(this.form.job.jobGroup) != 'undefined' && (
				this.form.job.jobGroup != JOB_ANGESTELLT ||
				(this.form.job.jobGroup == JOB_ANGESTELLT && this.form.job.partTime == 1)
			);*/
		},
		hasVisibleInsurancePackagePriceError: () => {
			return this.data.insurancePackagePriceError !== undefined && this.data.step == STEP3_INS;
		}
	};

	this.errors = {
		displayError: {
			docsDownloaded: false,
			unbindDiscretion: false,
			collectionData: false,
			eligibilityCode: false
		},
		display: p => {
			return this.errors.displayError[p] && this.errors.displayError[p] === true;
		},
		// premium package is not displayed, if:
		// user is JOB_ANGESTELLT and working partTime
		// JOB_FREELANCER and working less than 24 months
		// or JOB_BEAMTE
		// in those cases the ALO insurance isn't displayed on any other package either
		disabledPremium: () => {
			return this.form.job.jobGroup !== undefined &&
				(
					(this.form.job.jobGroup == JOB_ANGESTELLT && this.form.job.partTime == 1) ||
					(this.form.job.jobGroup == JOB_FREELANCER && this.form.job.reducedWork == 1) ||
					(this.form.job.jobGroup == JOB_BEAMTE || this.form.job.jobGroup == JOB_SONSTIGE)
				);
		},
		getVviDownloaded: () => {
			if (this.form.docsDownloaded === undefined) { return 0; }

			return this.form.docsDownloaded == 1 ? 0 : 1;
		},
		getUnbindDiscretion: () => {
			if (this.form.unbindDiscretion === undefined) { return 0; }

			return this.form.unbindDiscretion == 1 ? 0 : 1;
		},
		getCollectData: () => {
			if (this.form.collectionData === undefined) { return 0; }

			return this.form.collectionData == 1 ? 0 : 1;
		},
		getEligibilityCode: () => {
			if (this.form.eligibilityCode === undefined) { return 0; }
			if (this.form.eligibilityCode.length === 0) { return 1; }
			if (this.form.eligibilityCode.length !== 11 || this.form.eligibilityCode.match(/[^\d]/)) { return 2; }
			if (!checkCode(this.form.eligibilityCode)) { return 3; }

			return 0;
		}
	};

	/**
	 * Called on each step change, forward and backward.
	 * Sets the header progress svg icon, or animation or whatever is necessary.
	 */
	this.setProgress = (step, prevStep) => {
		let header = document.body.querySelector('header');
		if (header) {
			header.classList.remove(`step-${ prevStep }`);
			header.classList.add(`step-${ step }`);
		}
	};

	/**
	 * Internal function, purely for setting the variable step to a new value
	 * AND set the progress inside the header via native JS as it's the header where we do not have access via ng.
	 */
	this.setStep = step => {
		$timeout(() => {
			this.data.prevStep = this.data.step;
			this.setProgress(step, this.data.prevStep);

			this.data.step = step;
			if (step === STEP3_INS) {
				// render time
				$timeout(() => {
					createPackageSlider();
				}, 50);
			}
			if (step === STEP8_OVERVIEW) {
				// render time
				$timeout(() => {
					createOverviewSlider();
				}, 50);
			}

			$tagmanager.push(`page${ step }`);
			window.scrollTo(0, 0);
		}, 0);
	};

	/**
	 * Calculates the package costs.
	 * Uses the data entered inside Step 1 and 2, those steps will send their data here anyway.
	 * So we calc it here when user reaches step 3 (intermediate overview step) and send the data to step 4.
	 */
	this.checkCreditSum = () => {
		if (this.data.insPkgPriceQ !== undefined) {
			this.data.insPkgPriceQ.resolve('Abort');
			this.data.insPkgPriceQ = undefined;
		}

		// twice on purpose
		this.data.checkingCreditSum = true;
		$timeout(() => this.data.checkingCreditSum = true, 0);

		this.data.insPkgPriceQ = $q.defer();
		return $http({
			timeout: this.data.insPkgPriceQ.promise,
			method: 'POST',
			url: `/api/v1/insurance`,
			data: {
				credit: this.form.credit,
				job: this.form.job
			}
		}).then(resp => {
			let json = resp.data;
			if (!json.error) {
				this.form.addInsuranceCosts = json.data;
				// we simply send the returned data to the controller to display it
				channel.notify(
					`insurancePackageCost`,
					{ data: json.data }
				);
			} else {
				channel.notify(
					`insurancePackageCostError`,
					{ message: json.message }
				);
			}

			$timeout(() => {
				this.data.insPkgPriceQ = undefined;
				this.data.checkingCreditSum = false;
				this.data.insurancePackagePriceError = !!json.error ? json.message : undefined;
			}, 0);
		}, (err) => {
			channel.notify(
				`insurancePackageCostError`,
				{ message: err.data.message || 'Ein Fehler ist aufgetreten' }
			);

			$timeout(() => {
				this.data.insPkgPriceQ = undefined;
				this.data.checkingCreditSum = false;
				this.data.insurancePackagePriceError = err;
			}, 0);
			console.error(err);
		});
	};

	/**
	 * Tries to retrieve the VVI information.
	 */
	this.getVVI = () => {
		if (this.data.sending) { return; }
		$timeout(() => {
			this.data.sending = true;
			this.data.error = false;
		}, 0);

		$tagmanager.push('pageNext5');
		$http({
			method: 'POST',
			url: `/api/v1/vvi`,
			data: this.form
		}).then(resp => {
			let json = resp.data;
			if (!json.error) {
				$timeout(() => {
					this.data.sending = false;
					this.data.vviId = json.data.vviId;  // contains id to session

					this.setStep(STEP6_VVI);
				}, 0);
			} else {
				$timeout(() => {
					this.data.error = json.message;
					this.data.sending = false;
				}, 0);
			}
		}, err => {
			let json = err.data || undefined;
			$timeout(() => {
				this.data.sending = false;
				this.data.error = json && json.message || 'Es ist ein Fehler aufgetreten';
			}, 0);
		});
	};

	this.placeOrder = () => {
		if (this.data.sendingContract) { return; }
		$timeout(() => {
			this.data.sendingContract = true;
			this.data.error = false;
		}, 0);

		$tagmanager.push('ctaCompletion');
		$http({
			method: 'POST',
			url: `/api/v1/contract`,
			data: this.form
		}).then(resp => {
			let json = resp.data;
			if (!json.error) {
				$timeout(() => {
					this.data.sendingContract = false;

					this.setStep(STEP9_COMPLETION);
					this.data.contractId = json.data.contractId;
					this.tmpl.downloadContract();
				}, 0);
			} else {
				$timeout(() => {
					this.data.error = json.message;
					this.data.sendingContract = false;
				}, 0);
			}
		}, (err) => {
			$timeout(() => {
				this.data.sendingContract = false;
				this.data.error = 'Es ist ein Fehler aufgetreten';
			}, 0);

			console.error(err);
		});
	};

	// controller entry point
	this.main = () => {
		// other controller send their data here
		channel.register('collectFormData', data => {
			// twice on purpose, so our code has immediate access and second for angular to run $digest
			// VVI needs bank data but the timeout will happen after the ajax was sent
			this.form[data.key] = data.data;
			$timeout(() => {
				this.form[data.key] = data.data;
				// check if we got invalid data, and if so, remove premium selection
				if (data.key === 'job' && (data.data.jobGroup != JOB_ANGESTELLT || data.data.partTime == 1)) {
					channel.notify(`removePremiumSelection`, {});
				}
			}, 0);
		});

		[ 'docsDownloaded', 'eligibilityCode' ].forEach(key => {
			channel.register(`validation_${ key }`, data => {
				$timeout(() => this.errors.displayError[key] = data.displayError, 0);
			});
		});

		// All by this controller handled steps
		channel.register(`triggerValidationByStep_${ STEP6_VVI }`, data => {
			if (!this.form.docsDownloaded) {
				$timeout(() => {
					this.form.docsDownloaded = '';
					this.errors.displayError.docsDownloaded = true;

					document.querySelector('[validate-name="docsDownloaded"]').parentNode.scrollIntoView();
				}, 0);
			}

			return !!this.form.docsDownloaded;
		});

		channel.register(`triggerValidationByStep_${ STEP7_LEGAL }`, data => {
			let validInput = true;

			['collectionData', 'unbindDiscretion'].forEach(key => {
				if (!this.form[key]) {
					$timeout(() => {
						this.form[key] = '';
						this.errors.displayError[key] = true;

						document.querySelector(`[validate-name="${ key }"]`).parentNode.scrollIntoView();
					}, 0);
					validInput = false;
				}
			});

			return validInput;
		});

		channel.register(`triggerValidationByStep_${ STEP8_OVERVIEW }`, data => {
			if (this.errors.displayError['eligibilityCode']) {
				return false;
			} else if (this.errors.getEligibilityCode() !== 0) {
				this.errors.displayError['eligibilityCode'] = true;
				return false;
			} else if (this.form.eligibilityCode === undefined) {
				this.form.eligibilityCode = '';
				return false;
			}

			return true;
		});
		channel.register(`triggerValidationByStep_${ STEP9_COMPLETION }`, data => {
			return true;
		});

		// prePopulating, will return undefined if not available for these
		this.form.docsDownloaded = shared.getPopValueByKey('docsDownloaded');
		this.form.unbindDiscretion = shared.getPopValueByKey('unbindDiscretion');
		this.form.collectionData = shared.getPopValueByKey('collectionData');
		this.data.maxInsuranceRuntime = shared.getPopValueByKey('maxRuntimeInMonths');

		let catchOutgoingLinks = () => {
			let btnConfirmLeave = document.querySelector('.js-modal-leave');
			let btnModalLeave = document.querySelector('.js-modal-leave-application');
			let customModalShown = false;
			let modalLeave = document.querySelector('.js-modal[data-modal-id="leave-application"]');
			if (modalLeave) {
				modalLeave.addEventListener('modal.hide', (e) => {
					customModalShown = false;
				});
				modalLeave.addEventListener('modal.show', (e) => {
					customModalShown = true;
				});
			}

			if (btnConfirmLeave && btnModalLeave) {
				btnConfirmLeave.addEventListener('click', e => {
					location.href = btnConfirmLeave.getAttribute('data-link');
				});

				let outgoingLinks = Array.prototype.slice.call(document.querySelectorAll('.js-link-leave'));
				outgoingLinks.forEach(el => {
					el.addEventListener('click', e => {
						if (this.data.step < STEP9_COMPLETION) {
							e.preventDefault();
							btnConfirmLeave.setAttribute('data-link', el.href);
							btnModalLeave.click();
						}
					})
				});
			}

			// this opens a default popup in every browser to warn the user when using browser-functions
			window.addEventListener('beforeunload', e => {
				if (!customModalShown && this.data.step < STEP9_COMPLETION) {
					e.preventDefault();
					e.returnValue = '';
				}
			});
		};
		// We let the browser render first
		$timeout(() => catchOutgoingLinks(), 500);

		// Tippy creates the tooltips on click on the buttons
		// that's why we need to "hook" into the death button click to set the currently set benefit
		// there are no hooks in Tippy we could use, ng-bind does not work
		let dynamicTips = Array.prototype.slice.call(document.querySelectorAll('button[data-tooltip-target-id="death"]'));
		dynamicTips.forEach(tip => {
			tip.addEventListener('click', e => {
				setTimeout(() => {
					let death = document.querySelector('.tippy-tooltip .js-ng-death-benefit');
					if (death) {
						death.innerHTML = this.tmpl.getDeathBenefit();
					}
				}, 100);
			});
		});

		if (typeof(__PRESELECTPACKAGE) !== 'undefined') {
			setTimeout(() => {
				channel.notify(`preSelectPackage`, { pkg: __PRESELECTPACKAGE });
			}, 500);
		}
	};
	this.main();
}]);

// Credit information
app.controller('credit', ['shared', '$timeout', 'channel', function(shared, $timeout, channel) {
	this.form = {
		creditSum: undefined,
		monthlyRate: undefined,
		runtime: undefined,
		paymentMonth: undefined,
		honestInput: undefined,
	};

	this.errors = {
		displayError: {
			creditSum: false,
			monthlyRate: false,
			runtime: false,
			paymentMonth: false,
			honestInput: false,
		},
		display: p => {
			return this.errors.displayError[p] && this.errors.displayError[p] === true;
		},
		getCreditSum: () => {
			if (this.form.creditSum === undefined) { return 0; }

			let msgs = {
				ERR_EMPTY:		[
									this.form.creditSum.length === 0 ||
									this.form.creditSum.length > 1 && this.form.creditSum[0] == '0' ||
									!this.form.creditSum.match(/^\d+(,\d{1,2}|)$/),
									1
								],
				ERR_INVALID:	[
									this.form.creditSum.toString().replace(',', '.').match(/\d+(\.\d{1,2}|)$/) === null ||
									this.form.creditSum.toString().match(/\./) !== null,		// only comma allowed
									2
								],
				ERR_TOOLOW:		[ parseFloat(this.form.creditSum.replace(',', '.')) < 2000, 3 ],
				ERR_TOOHIGH:	[ parseFloat(this.form.creditSum.replace(',', '.')) > 110000, 4 ],
				ERR_CREDITSUM:	[
									this.form.runtime !== undefined && this.form.runtime.length > 1 && 
									this.form.monthlyRate !== undefined && this.form.monthlyRate.length > 1 && this.form.monthlyRate.match(/^\d+(,\d{1,2}|)$/) &&
									parseFloat(this.form.creditSum.replace(',', '.')) > parseFloat(this.form.monthlyRate.replace(',', '.')) * parseFloat(this.form.runtime),
									5
								]
			};

			// Let's check if any of the above conditions were true or not,
			// if they are, we return the corresponding error
			for (const [key, value] of Object.entries(msgs)) {
				if (value[0] === true) {
					document.querySelector('.js-credit-container').classList.add('visible-error');
					return value[1];
				}
			}

			document.querySelector('.js-credit-container').classList.remove('visible-error');
			return 0;
		},
		getMonthlyRate: () => {
			if (this.form.monthlyRate === undefined) { return 0; }

			let msgs = {
				ERR_EMPTY:		[
									this.form.monthlyRate.length === 0 ||
									this.form.monthlyRate.length > 1 && this.form.monthlyRate[0] == '0' ||
									!this.form.monthlyRate.match(/^\d+(,\d{1,2}|)$/),
									1
								],
				ERR_INVALID:	[
									this.form.monthlyRate.toString().replace(',', '.').match(/\d+(\.\d{1,2}|)$/) === null ||
									this.form.monthlyRate.toString().match(/\./) !== null		// only comma allowed
								, 2 ],
				ERR_TOOLOW:		[ parseFloat(this.form.monthlyRate.replace(',', '.')) < 50, 3 ],
				ERR_TOOHIGH:	[ parseFloat(this.form.monthlyRate.replace(',', '.')) > 2500, 4 ],
			};

			this.form.monthlyRate.length > 1 && this.errors.getCreditSum();
			for (const [key, value] of Object.entries(msgs)) {
				if (value[0] === true) {
					return value[1];
				}
			}

			return 0;
		},
		getDuration: () => {
			if (this.form.runtime === undefined) { return 0; }

			let msgs = {
				ERR_EMPTY:	[
								this.form.runtime.length === 0 || Number.isNaN(this.form.runtime%1) ||
								this.form.runtime.length > 1 && this.form.runtime[0] == '0' ||
								!!this.form.runtime.toString().match(/\./),
								1
							],
				ERR_TOOLOW:	[ parseFloat(this.form.runtime) < 12, 2 ],
				ERR_TOOHIGH:[ parseFloat(this.form.runtime) > 120, 3 ],
			};

			this.form.runtime.length > 1 && this.errors.getCreditSum();
			for (const [key, value] of Object.entries(msgs)) {
				if (value[0] === true) {
					return value[1];
				}
			}

			return 0;
		},
		getPaymentMonth: () => {
			if (this.form.paymentMonth === undefined) { return 0; }

			let _d = DateTime.fromFormat(this.form.paymentMonth.toString(), 'MM.yyyy');
			let _diff = -1*_d.diffNow('months').months;

			let curDate = DateTime.utc().startOf('month');
			let msgs = {
				ERR_EMPTY:		[ this.form.paymentMonth.length === 0, 1 ],
				ERR_INVALID:	[ !_d.isValid || Number.isNaN(_diff), 2 ],
				ERR_TOOHIGH:	[ _d.isValid && _diff > 12, 3 ],
				ERR_TOOLATE:	[ _d.isValid && _d.valueOf() > curDate.valueOf(), 4 ],
			};

			for (const [key, value] of Object.entries(msgs)) {
				if (value[0] === true) {
					return value[1];
				}
			}

			return 0;
		},
		getHonestInput: () => {
			if (this.form.honestInput === undefined) { return 0; }

			return this.form.honestInput !== true ? 1 : 0;
		}
	};

	this.checkInput = async () => {
		let validInput = true;
		let order = {
			creditSum: false, monthlyRate: false, runtime: false, paymentMonth: false, honestInput: false
		};

		let notifyInputs = async () => {
			// To display error messages, the values must be non-undefined, we cannot set checkbox types, etc as strings
			let defaultValues = {
				creditSum: '', monthlyRate: '', runtime: '', paymentMonth: '', honestInput: false
			};
			let keys = Object.keys(order);

			return Promise.all(
				keys.map(
					key => channel.notify(`triggerValidationByName_${ key }`, {})
				)
			).then(results => {
				results.map((result, i) => {
					if (Array.isArray(result)) {
						order[keys[i]] = result[0];

						if (result[0]) {
							$timeout(() => {
								if (this.form[keys[i]] === undefined) {
									this.form[keys[i]] = defaultValues[keys[i]];
								}
							}, 0);
							validInput = false;
						}

						return result[0];
					} else {
						// if not an array it's undefined,
						// that means order[i] is not present in the template, check the name and input and fix that
						order[keys[i]] = true;

						$timeout(() => {
							if (this.form[keys[i]] === undefined) {
								this.form[keys[i]] = defaultValues[keys[i]];
							}
						}, 0);
						validInput = false;

						return false;
					}
				})
			});
		};
		await notifyInputs();
		$timeout(() => this.errors.displayError = order, 0);

		try {
			Object.keys(order).some(
				key => order[key] === true ? (document.querySelector(`[validate-name="${ key }"]`).parentNode.parentNode.scrollIntoView(), true) : false
			);
		} catch (e) {
			//
		}

		return validInput;
	};

	// controller entry point
	this.main = () => {
		channel.register('collectFormDataCredit', data => {
			channel.notify(
				`collectFormData`,
				{
					key: 'credit',
					data: this.form
				}
			);
		});

		Object.keys(this.form).forEach(key => {
			channel.register(`validation_${ key }`, data => {
				$timeout(() => this.errors.displayError[key] = data.displayError, 0);
			});
		});

		channel.register(`triggerValidationByStep_${ STEP1_CREDIT }`, data => {
			return this.checkInput();
		});

		if (typeof(__PREFILL) !== 'undefined') {
			window.__PREPOPULATE = window.__PREPOPULATE || {};
			window.__PREPOPULATE.credit = {
				creditSum: __PREFILL?.creditSum ? __PREFILL.creditSum.toString().replace('.', ',') : undefined,
				monthlyRate: __PREFILL?.monthlyRate ? __PREFILL.monthlyRate.toString().replace('.', ',') : undefined,
				runtime: __PREFILL?.runtime ? __PREFILL.runtime.toString() : undefined,
				paymentMonth: __PREFILL?.paymentMonth ? DateTime.fromMillis(__PREFILL.paymentMonth).toFormat('MM.yyyy') : undefined,
				honestInput: true,
			};
		}

		shared.populate(this, 'credit', [
			'creditSum', 'monthlyRate', 'runtime', 'paymentMonth', 'honestInput'
		]);

		try {
			if (typeof(__PREFILL) === 'undefined') {
				document.querySelector('.js-modal-three-minutes').click();
			}
		} catch (e) {
			//
		}
	};
	this.main();
}]);

// Job information
app.controller('job', ['shared', 'channel', '$timeout', function(shared, channel, $timeout) {
	this.form = {
		jobGroup: undefined,
		partTime: undefined,
		reducedWork: undefined,
		salutation: undefined,
		birthday: undefined,
	};
	this.data = {
		partTimeInput: undefined,
		reducedWorkInput: undefined,
	}
	this.errors = {
		displayError: {
			jobGroup: false,
			partTime: false,
			reducedWork: false,
			salutation: false,
			birthday: false,
		},
		display: p => {
			return this.errors.displayError[p] && this.errors.displayError[p] === true;
		},
		getJobGroup: () => {
			if (this.form.jobGroup === undefined) { return 0; }

			return this.form.jobGroup.length === 0 ? 1 : 0;
		},
		getPartTime: () => {
			if (this.form.partTime === undefined) { return 0; }
			if (this.form.partTime.length === 0) { return 1; }  // '' != 0 => false, not what we want

			return this.form.partTime != 0 && this.form.partTime != 1 ? 1 : 0;
		},
		getReducedWork: () => {
			if (this.form.reducedWork === undefined) { return 0; }
			if (this.form.reducedWork.length === 0) { return 1; }  // '' != 0 => false, not what we want

			return this.form.reducedWork != 0 && this.form.reducedWork != 1 ? 1 : 0;
		},
		getBirthday: () => {
			if (this.form.birthday === undefined) { return 0; }
			if (this.form.birthday.length === 0) { return 1; }

			let _d = DateTime.fromFormat(this.form.birthday, 'dd.MM.yyyy');
			if (!_d.isValid) { return 2; }

			// years will be negative that's why -1*; age will be float, with partial years
			let age = -1*_d.diffNow('years').years;

			if (age < 18) {
				return 3;
			} else if (age >= 64) {
				return 4;
			}

			return 0;
		},
		getSalutation: () => {
			if (this.form.salutation === undefined) { return 0; }

			return this.form.salutation.length === 0 ? 1 : 0;
		}
	};

	this.tmpl = {
		hidePartTime: () => {
			return this.form.jobGroup != JOB_ANGESTELLT && this.form.jobGroup != undefined && this.form.jobGroup != '';
		},
		hideReducedWork: () => {
			return this.form.jobGroup != JOB_FREELANCER;
		},
		selectGroup: () => {
			if (this.form.jobGroup != JOB_ANGESTELLT) {
				$timeout(() => {
					this.form.partTime = undefined;
					this.errors.displayError.partTime = false;
					this.data.partTimeInput = undefined;
				}, 0);
			}
			if (this.form.jobGroup != JOB_FREELANCER) {
				$timeout(() => {
					this.form.reducedWork = undefined;
					this.errors.displayError.reducedWork = false;
					this.data.reducedWorkInput = undefined;
				}, 0);
			}
		},
		setPartTime: type => {
			if (this.form.partTime !== type) {  // only change if a change happened
				$timeout(() => this.form.partTime = type, 0);
			}
		},
		selectSalutation: () => {
			$timeout(() => this.errors.displayError.salutation = (!this.form.salutation != '1' && !this.form.salutation == '2'), 0);
		},
		setReducedWork: type => {
			if (this.form.reducedWork !== type) {  // only change if a change happened
				$timeout(() => this.form.reducedWork = type, 0);
			}
		}
	};

	this.checkInput = async () => {
		let validInput = true;
		let order = {
			jobGroup: false, salutation: false, birthday: false,
		};
		if (this.form.jobGroup == JOB_ANGESTELLT) {
			order['partTime'] = false;
		} else if (this.form.jobGroup == JOB_FREELANCER) {
			order['reducedWork'] = false;
		}

		let notifyInputs = async () => {
			// To display error messages, the values must be non-undefined, we cannot set checkbox types, etc as strings
			let defaultValues = {
				jobGroup: '', partTime: '', reducedWork: '', salutation: '', birthday: '',
			};
			let keys = Object.keys(order);

			return Promise.all(
				keys.map(
					key => channel.notify(`triggerValidationByName_${ key }`, {})
				)
			).then(results => {
				results.map((result, i) => {
					if (Array.isArray(result)) {
						order[keys[i]] = result[0];

						if (result[0]) {
							$timeout(() => {
								if (this.form[keys[i]] === undefined) {
									this.form[keys[i]] = defaultValues[keys[i]];
								}
							}, 0);
							validInput = false;
						}

						return result[0];
					} else {
						// if not an array it's undefined,
						// that means order[i] is not present in the template, check the name and input and fix that
						order[keys[i]] = true;

						$timeout(() => {
							if (this.form[keys[i]] === undefined) {
								this.form[keys[i]] = defaultValues[keys[i]];
							}
						}, 0);
						validInput = false;

						return false;
					}
				})
			});
		};

		await notifyInputs();
		$timeout(() => this.errors.displayError = order, 0);

		try {
			Object.keys(order).some(
				key => order[key] === true ? (document.querySelector(`[validate-name="${ key }"]`).parentNode.parentNode.scrollIntoView(), true) : false
			);
		} catch (e) {
			//
		}

		return validInput;
	};

	// controller entry point
	this.main = () => {
		channel.register('collectFormDataJob', data => {
			channel.notify(
				`collectFormData`,
				{
					key: 'job',
					data: this.form
				}
			);
		});

		Object.keys(this.form).forEach(key => {
			channel.register(`validation_${ key }`, data => {
				$timeout(() => this.errors.displayError[key] = data.displayError, 0);
			});
		});

		channel.register(`triggerValidationByStep_${ STEP2_JOB }`, data => {
			if (typeof(__PRESELECTPACKAGE) !== 'undefined' && __PRESELECTPACKAGE === 'premium') {
				if (this.form.jobGroup != JOB_ANGESTELLT ||
					(this.form.jobGroup == JOB_ANGESTELLT && this.form.partTime == 1)
				) {
					channel.notify('removePremiumSelection', {});
					// reset, so this is only done once
					__PRESELECTPACKAGE = '';
					try {
						history.replaceState({}, document.title, document.URL.split('/').slice(0, -1).join('/'))
					} catch (e) {
						//
					}
				}
			}

			return this.checkInput();
		});

		if (typeof(__PREFILL) !== 'undefined') {
			window.__PREPOPULATE = window.__PREPOPULATE || {};
			window.__PREPOPULATE.job = {
				jobGroup: typeof(__PREFILL.jobGroup) !== 'undefined' ? __PREFILL.jobGroup.toString() : undefined,
				partTime: __PREFILL?.partTime ? __PREFILL.partTime.toString() : undefined,
				salutation: __PREFILL?.salutation ? __PREFILL.salutation.toString() : undefined,
				birthday: __PREFILL?.birthday ? DateTime.fromMillis(__PREFILL.birthday).toFormat('dd.MM.yyyy') : undefined,
			};

			// Update label to be displayed on top of select
			let selectJob = document.querySelector('#jobgroup');
			if (selectJob) {
				selectJob.closest('.form-select')?.classList?.add('filled');
			}
			let selectSalutation = document.querySelector('#salutation');
			if (selectSalutation) {
				selectSalutation.closest('.form-select')?.classList?.add('filled');
			}
		}

		shared.populate(this, 'job', [
			'jobGroup', 'partTime', 'salutation', 'birthday'
		]);
	};
	this.main();
}]);

// Alternate insurances
app.controller('addInsurance', ['shared', 'channel', '$timeout', '$scope', function(shared, channel, $timeout, $scope) {
	this.data = {
		autoCompleteQ: undefined,
		packagePriceError: undefined,
	};

	this.form = {
		selectedPackage: undefined,  // empty string means no additional insurance selected
		packagePrices: {
			basis: {},
			komfort: {},
			premium: {},
			// result from API call, that is done in appCtrl
		}
	};

	this.errors = {
		displayError: {
			selectedPackage: false,
		},
		display: p => {
			return this.errors.displayError[p] && this.errors.displayError[p] === true;
		},
	};

	this.tmpl = {
		selectedPkg: () => {
			return this.form.selectedPackage;
		},
		unselectPkg: () => {
			$timeout(() => {
				this.form.selectedPackage = undefined;
				this.notify();
			}, 0);
		},
		selectPackage: pkg => {
			$timeout(() => {
				this.form.selectedPackage = pkg;

				// reset error display
				this.errors.displayError.selectedPackage = false;

				this.notify();
			}, 0);
		},
		getPackagePrice: pkg => {
			if (this.data.packagePriceError !== undefined) { return '-'; };
			if (typeof(this.form.packagePrices[pkg].insurance1Result) === 'undefined') { return '-'; }

			let format = this.form.packagePrices[pkg].insurance1Result.premiumTotal.toString().replace('.', ',');
			let parts = format.split(',');
			if (parts.length < 2) {  // if the API returns just "7"
				return format + ',00';
			}

			if (parts[1].length < 2) {  // if the API returns 7,1
				return format + '0';
			}

			return format;
		},
	};
	this.notify = () => {
		channel.notify(
			`collectFormData`,
			{
				key: 'addInsurance',
				data: this.form
			}
		);
	};

	this.checkInput = async () => {
		let order = {
			selectedPackage: false
		};
		// if any package was selected, do not trigger error
		if (this.form.selectedPackage !== undefined) { return true; }

		if (![ 'basis', 'komfort', 'premium' ].some(pkg => this.form.selectedPackage === pkg)) {
			order.selectedPackage = true;
			$timeout(() => this.errors.displayError = order, 0);
			return false;
		}

		return true;
	};

	// controller entry point
	this.main = () => {
		channel.register('collectFormDataAddInsurance', data => {
			this.notify();
		});
		channel.register('preSelectPackage', data => {
			this.tmpl.selectPackage(data.pkg);
		});
		channel.register('insurancePackageCost', data => {
			this.form.packagePrices = data.data;
			this.data.packagePriceError = undefined;
		});
		channel.register('insurancePackageCostError', data => {
			this.data.packagePriceError = data.message;
			this.form.packagePrices = { basis: {}, komfort: {}, premium: {} };

			try { document.querySelector('.js-modal-expired-credit').click(); } catch (e) { }
		});

		// prev button usage, if user previously selected premium changes pers data making it unavailable
		// we get this notification
		channel.register('removePremiumSelection', data => {
			if (this.form.selectedPackage === 'premium') {
				// notifies application back, which in turn removes data from sticky footer
				this.tmpl.unselectPkg();
			}
		});

		Object.keys(this.form).forEach(key => {
			channel.register(`validation_${ key }`, data => {
				$timeout(() => this.errors.displayError[key] = data.displayError, 0);
			});
		});

		channel.register(`triggerValidationByStep_${ STEP3_INS }`, data => {
			return this.checkInput();
		});

		shared.populate(this, 'addInsurance', [
			'selectedPackage', 'packagePrices'
		]);
	};
	this.main();
}]);

// Personal information, contains autoComplete for city
app.controller('personal', ['$timeout', '$http', '$q', 'shared', 'channel', function($timeout, $http, $q, shared, channel) {
	this.data = {
		autoCompleteQ: undefined,
		lastZipCheckSearch: undefined,
		lastZipCheckResponse: undefined,
		toZip: undefined,
		toMail: undefined,
	};

	this.form = {
		salutation: undefined,  // prefill with data from job controller
		firstName: undefined,
		lastName: undefined,
		street: undefined,  // incl. house number
		zipCode: undefined,
		city: undefined,  // autocompleted
		birthday: undefined,  // prefill with data from job controller
		birthPlace: undefined,
		email: undefined,
		ownInterest: undefined,
	};

	this.errors = {
		displayError: {
			firstName: false, lastName: false,
			street: false,
			zipCode: false, city: false,
			birthPlace: false, email: false,
			ownInterest: false,
			phoneNumber: false,
		},
		display: p => {
			if (p === 'phoneNumber') {  // only necessary if phone as contact is enabled
				if (this.form.contactViaPhone == 1) {
					return this.errors.displayError[p] === true;
				}
			}

			return this.errors.displayError[p] && this.errors.displayError[p] === true;
		},
		getFirstName: () => {
			if (this.form.firstName === undefined) { return 0; }
			if (this.form.firstName.length === 0) { return 1; }

			return 0;
		},
		getLastName: () => {
			if (this.form.lastName === undefined) { return 0; }
			if (this.form.lastName.length === 0) { return 1; }

			return 0;
		},
		getStreet: () => {
			if (this.form.street === undefined) { return 0; }
			if (this.form.street.length === 0) { return 1; }

			return 0;
		},
		getZipCode: () => {
			if (this.form.zipCode === undefined) { return 0; }

			if (this.form.zipCode.length === 0 || this.form.zipCode.length !== 5) {
				return this.form.zipCode.length === 0 ? 1 : 2;
			}

			return 0;
		},
		getCity: () => {
			if (this.form.city === undefined) { return 0; }
			if (this.form.city.length === 0) { return 1; }

			return 0;
		},
		getPlaceOfBirth: () => {
			if (this.form.birthPlace === undefined) { return 0; }
			if (this.form.birthPlace.length === 0) { return 1; }

			return 0;
		},
		getMail: () => {
			if (this.form.email === undefined) { return 0; }
			if (this.form.email.length === 0) { return 1; }
			$timeout.cancel(this.data.toMail);

			if (this.form.email.match(/^[a-z0-9_\-\.]+@[a-z0-9_\-\.]+\.[a-z0-9]+$/i) === null) {
				this.data.toMail = $timeout(() => this.errors.displayError.email = true, 50);

				return 2;
			}

			this.data.toMail = $timeout(() => this.errors.displayError.email = false, 50);
			return 0;
		},
		getPhone: () => {
			if (this.form.contactViaPhone === undefined || this.form.contactViaPhone != 1) { return 0; }
			if (this.form.phoneNumber === undefined) { return 0; }
			if (this.form.phoneNumber.length === 0) { return 1; }

			return 0;
		},
		getCommercialInterest: () => {
			if (this.form.ownInterest === undefined) { return 0; }

			return !this.form.ownInterest ? 1 : 0;
		}
	};

	this.tmpl = {
		// prevents the validation to display "enter phone" if mail is clicked
		clearPhoneContact: () => {
			this.form.phoneNumber = undefined;
		},
		pollZipCode: () => {
			$timeout(() => this.errors.displayError.zipCode = this.form.zipCode.length != 5, 0);
			if (this.form.zipCode.length != 5) {
				return;
			}

			if (this.form.zipCode === undefined || this.form.zipCode.length === 0) { return; }
			else if (this.form.zipCode.length < 5 && this.data.lastZipCheckResponse == this.form.city) {  // do not delete user input, unless it coincides with the last zipcode
				$timeout(() => {
					this.form.city = '';
				}, 0);
			}

			if (this.data.lastZipCheckResponse !== undefined && this.data.lastZipCheckResponse.length === 1
				&& this.data.lastZipCheckSearch === this.form.zipCode) {
				$timeout(() => {
					this.form.city = this.data.lastZipCheckResponse[0][1];
					this.errors.displayError.city = false;
				}, 0);
			} else {
				this.data.autoCompleteQ = $q.defer();
				$http({
					timeout: this.data.autoCompleteQ.promise,
					method: 'GET',
					url: `/api/v1/plz-city/${ this.form.zipCode }`
				}).then((resp) => {
					this.data.lastZipCheckSearch = this.form.zipCode;
					if (!resp.data.error) {
						if (resp.data.cities.length === 1) {
							let oldCheck = this.data.lastZipCheckResponse != undefined ? this.data.lastZipCheckResponse[0][1] : undefined;
							$timeout(() => {
								this.errors.displayError.city = false;

								if (this.form.city === undefined || this.form.city.length === 0 || oldCheck === this.form.city) {
									this.form.city = resp.data.cities[0][1];
								}
							}, 0);
						}

						this.data.lastZipCheckResponse = resp.data.cities;
						return;
					}

					$timeout(() => {
						this.form.city = undefined;
						this.errors.displayError.city = true;
					}, 0);
				}, (err) => {
					$timeout(() => {
						this.form.city = '';
						this.errors.displayError.city = true;
					}, 0);
				});
			}
		},
	};

	this.checkInput = async () => {
		let validInput = true;
		let order = {
			firstName: false, lastName: false,
			street: false, zipCode: false, city: false,
			birthPlace: false, email: false,
			ownInterest: false
		};
		if (this.form.contactViaPhone == 1) {  // validity check for phone only if enabled
			order['phoneNumber'] = false;
		}

		let notifyInputs = async () => {
			// To display error messages, the values must be non-undefined, we cannot set checkbox types, etc as strings
			let defaultValues = {
				firstName: '', lastName: '',
				street: '', zipCode: '', city: '',
				birthPlace: '', email: '',
				ownInterest: '', phoneNumber: ''
			};
			let keys = Object.keys(order);

			return Promise.all(
				keys.map(
					key => channel.notify(`triggerValidationByName_${ key }`, {})
				)
			).then(results => {
				results.map((result, i) => {
					if (Array.isArray(result)) {
						order[keys[i]] = result[0];

						if (result[0]) {
							$timeout(() => {
								if (this.form[keys[i]] === undefined) {
									this.form[keys[i]] = defaultValues[keys[i]];
								}
							}, 0);
							validInput = false;
						}

						return result[0];
					} else {
						// if not an array it's undefined,
						// that means order[i] is not present in the template, check the name and input and fix that
						order[keys[i]] = true;

						$timeout(() => {
							if (this.form[keys[i]] === undefined) {
								this.form[keys[i]] = defaultValues[keys[i]];
							}
						}, 0);
						validInput = false;

						return false;
					}
				})
			});
		};

		await notifyInputs();
		$timeout(() => this.errors.displayError = order, 0);

		try {
			Object.keys(order).some(
				key => order[key] === true ? (document.querySelector(`[validate-name="${ key }"]`).parentNode.parentNode.scrollIntoView(), true) : false
			);
		} catch (e) {
			//
		}

		return validInput;
	};

	// controller entry point
	this.main = () => {
		channel.register('collectFormDataPersonal', data => {
			channel.notify(
				`collectFormData`,
				{
					key: 'personal',
					data: this.form
				}
			);
		});

		// update the birthday readonly input
		channel.register(`collectFormData`, data => {
			if (data.key === 'job') {
				$timeout(() => {
					this.form.birthday = data.data.birthday;
					this.form.salutation = data.data.salutation == '1' ? 'Herr' : 'Frau';
				}, 0);
			}
		});

		Object.keys(this.form).forEach(key => {
			channel.register(`validation_${ key }`, data => {
				$timeout(() => this.errors.displayError[key] = data.displayError, 0);
			});
		});

		channel.register(`triggerValidationByStep_${ STEP4_PERSONAL }`, data => {
			return this.checkInput();
		});

		shared.populate(this, 'personal', [
			'salutation', 'firstName', 'lastName', 'street', 'zipCode', 'city', 'birthday', 'birthPlace', 'email',
		]);
	};
	this.main();
}]);

// Bank data, makes http requests for iban validation
app.controller('bank', ['$timeout', '$http', '$q', 'shared', 'channel', function($timeout, $http, $q, shared, channel) {
	this.data = {
		autoCompleteQ: undefined,
		lastCheck: '',
		checkingIban: false,
		invalidIban: false,
		lastBic: undefined,
		lastBank: undefined,
		toIban: undefined,
	};

	this.form = {
		sepa: undefined,
		iban: undefined,
		bic: '',
		bank: '',
	};

	this.tmpl = {
		checkingIban: () => this.data.checkingIban,
	};

	this.errors = {
		displayError: {
			sepa: false,
			iban: false,
		},
		display: p => {
			return this.errors.displayError[p] && this.errors.displayError[p] === true;
		},
		getSepa: () => {
			if (this.form.sepa === undefined) { return 0; }

			return this.form.sepa == 0 ? 1 : 0;
		},
		getIban: () => {
			if (this.form.iban === undefined) { return 0; }
			if (!!this.form.iban.replace(/ /g, '').match(/^\D{2}\d{20}$/i)) { return 0; }

			$timeout.cancel(this.data.toIban);
			this.data.toIban = $timeout(() => this.errors.displayError.iban = true, 0);
			if (this.form.iban.length === 0 || this.data.invalidIban) {
				return 1;
			}

			return 2;
		},
	};

	this.checkIban = iban => {
		if (this.data.lastCheck === iban) {
			// we can use the last used response
			$timeout(() => {
				this.form.bic = this.data.lastBic;
				this.form.bank = this.data.lastBank;

				if (this.data.lastBank !== undefined) {
					this.errors.displayError.iban = false;
					this.data.invalidIban = false;
				}
			}, 0);
			return;
		} else if (this.data.checkingIban) {
			return;
		}

		if (this.data.autoCompleteQ !== undefined) {
			this.data.autoCompleteQ.resolve('Abort');
			this.data.autoCompleteQ = undefined;
		}
		this.data.autoCompleteQ = $q.defer();
		this.data.lastCheck = iban;

		$timeout(() => {
			this.data.checkingIban = true;

			this.form.bic = undefined;
			this.form.bank = undefined;
		}, 0);

		$http({
			timeout: this.data.autoCompleteQ.promise,
			method: 'POST',
			url: `/api/v1/check/iban`,
			data: { iban }
		}).then(resp => {
			let json = resp.data;
			if (!json.error) {
				$timeout(() => {
					this.form.bic = json.data.bic;
					this.form.bank = json.data.bank;
					// cache
					this.data.lastBic = json.data.bic;
					this.data.lastBank = json.data.bank;

					this.errors.displayError.iban = false;
					this.data.invalidIban = false;
					this.data.checkingIban = false;
				}, 0);
			} else {
				$timeout(() => {
					this.errors.displayError.iban = true;
					this.data.invalidIban = true;

					// clear cache
					this.data.lastBic = undefined;
					this.data.lastBank = undefined;

					this.data.checkingIban = false;
				}, 0);
			}
		}, (err) => {
			$timeout(() => {
				this.errors.displayError.iban = true;
				this.data.invalidIban = true;

				// clear cache
				this.data.lastBic = undefined;
				this.data.lastBank = undefined;

				this.data.checkingIban = false;
			}, 0);
		});
	};

	this.checkInput = async () => {
		let validInput = true;
		let order = {
			iban: false, sepa: false
		};

		let notifyInputs = async () => {
			// To display error messages, the values must be non-undefined, we cannot set checkbox types, etc as strings
			let defaultValues = {
				iban: '', sepa: ''
			};
			let keys = Object.keys(order);

			return Promise.all(
				keys.map(
					key => channel.notify(`triggerValidationByName_${ key }`, {})
				)
			).then(results => {
				results.map((result, i) => {
					if (Array.isArray(result)) {
						order[keys[i]] = result[0];

						if (result[0]) {
							$timeout(() => {
								if (this.form[keys[i]] === undefined) {
									this.form[keys[i]] = defaultValues[keys[i]];
								}
							}, 0);
							validInput = false;
						} else if (keys[i] === 'iban' && this.data.invalidIban) {
							validInput = false;
							order[keys[i]] = true;  // display error
						}

						return result[0];
					} else {
						// if not an array it's undefined,
						// that means order[i] is not present in the template, check the name and input and fix that
						order[keys[i]] = true;

						$timeout(() => {
							if (this.form[keys[i]] === undefined) {
								this.form[keys[i]] = defaultValues[keys[i]];
							}
						}, 0);
						validInput = false;

						return false;
					}
				})
			});
		};

		await notifyInputs();
		$timeout(() => this.errors.displayError = order, 0);

		try {
			Object.keys(order).some(
				key => order[key] === true ? (document.querySelector(`[validate-name="${ key }"]`).scrollIntoView(), true) : false
			);
		} catch (e) {
			//
		}

		return validInput && !this.data.checkingIban;
	};

	// controller entry point
	this.main = () => {
		channel.register('collectFormDataBank', data => {
			channel.notify(
				`collectFormData`,
				{
					key: 'bank',
					data: this.form
				}
			);
		});

		Object.keys(this.form).forEach(key => {
			channel.register(`validation_${ key }`, data => {
				$timeout(() => this.errors.displayError[key] = data.displayError, 0);
			});
		});

		channel.register(`triggerValidationByStep_${ STEP5_BANK }`, data => {
			return this.checkInput();
		});

		let inputIban = document.querySelector('.js-input-iban');
		if (inputIban) {
			inputIban.addEventListener('keyup', () => {
				if (inputIban.value.replace(/ /g, '').length === 22 && inputIban.value.replace(/ /g, '').match(/^\D{2}\d{20}$/i)) {
					// we need to blur the input before checkIban,
					// or the next blur event triggers validate and removes any previously displayed error message
					inputIban.blur();

					this.checkIban(inputIban.value.replace(/ /g, ''));
				} else {
					// we can use the cached response
					$timeout(() => {
						this.form.bic = undefined;
						this.form.bank = undefined;

						this.data.invalidIban = true;
					}, 0);
				}
			});
		}

		// free contract has no data to populate for this controller
		/*shared.populate(this, 'bank', [
			'sepa', 'iban', 'bic', 'bank'
		]);*/
	};
	this.main();
}]);

// This object contains custom validator rules,
// each "rule" has an ID that has to be given to the validate attribute on input fields
// Multiple input fields can share a single rule
// Each rule must return a boolean indicating whether it is a valid input (true) or not (false)
// Possible rule types:
// function					gets a parameter with the current input to validate
// boolean	true | false	false for disabling validation, true if the "type" if the input should be checked, ie number for numbers
// RegExp object			Any kind of regular expression to match the current input against, a match means true means valid
let validator = {
	address: function(input) {
		return true;
	},
	phoneCountry: function(input) {
		return input !== null && input.match(/^(\+[\d ]+?|[\d ]+?)$/);  // country can have + character
	},
	phone: function(input) {
		return input !== null && input.match(/^([\d ]+?)$/);
	},
	mail: new RegExp("^[a-z0-9_\\-\\.]+@[a-z0-9_\\-\\.]+\\.[a-z0-9]+$", "i"),
	birthday: function(input) {
		try {
			// years will be negative
			let age = -1*DateTime.fromFormat(input, 'dd.MM.yyyy').diffNow('years').years;

			if (Number.isNaN(age) || age < 18 || age >= 64) {
				return false;
			}
		} catch (e) {
			return false;
		}

		return true;
	},
	nonEmpty: function(input, obj) {
		return input !== null && input.length > 0;
	},
	nonEmptyAlpha: function(input) {
		return input !== null && input.length > 0 && !input.match(/\d/g);
	},
	nonZero: function(input) {
		return parseFloat( input.replace(/\.[a-zA-Züöäß€]/g,'').replace(/,/, '.') ) > 0;
	},
	zipCode: function(input) {
		return input !== null && input.length === 5 && input.match(/^\d{5}$/i);
	},
	iban: function(v) {
		return v.replace(/ /g, '').match(/^\D{2}\d{20}$/i);
	},
	insuranceStart: function(v) {
		try {
			// date input specific format we get here: Sat Jan 01 2000 00:00:00 GMT+0100 (Mitteleuropäische Normalzeit)
			// the parenthesis makes issues with parsing within DateTime, so we create a JS Date
			let d = DateTime.fromFormat(v, 'dd.MM.yyyy');
			let cTime = DateTime.utc();
			return d.isValid && d.valueOf() > cTime.valueOf();
		} catch (e) {
			return false;
		}
	},
	creditSum: v => {
		let creditRate = document.querySelector('.js-credit-rates').value;
		let creditRuntime = document.querySelector('.js-credit-runtime').value;

		let w = v ? v.toString().replace('.', 'X').replace(',', '.') : false;
		return w && (w.length > 0 && w[0] != '0') && w >= 2000 && w <= 110000 && w.match(/^\d+(\.\d{1,2}|)$/) && (
				creditRate.length === 0 || creditRuntime.length === 0 || 
				(
					creditRate.length > 0 && creditRuntime >= 12 && 
					w <= parseFloat(creditRate.replace(',', '.')) * creditRuntime
				)
			);
	},
	monthlyRate: v => {
		let w = v ? v.toString().replace('.', 'X').replace(',', '.') : false;
		return w && (w.length > 0 && w[0] != '0') && w >= 50 && w <= 2500 && w.match(/^\d+(\.\d{1,2}|)$/);
	},
	runtime: v => {
		let w = v ? v.toString().replace('.', 'X') : false;
		return w && (w.length > 0 && w[0] != '0') && !Number.isNaN(w%1) && w >= 12 && w <= 120 && w % 1 == 0;
	},
	paymentMonth: v => {
		if (!v || v.toString().length === 0 || !v.match(/^[0-9]{2}\.[0-9]{4}$/)) { return false; }

		let _d = DateTime.fromFormat(v, 'MM.yyyy');
		let _diff = -1*_d.diffNow('months').months;
		if (!_d.isValid || Number.isNaN(_diff) || _d.isValid && _diff > 12) {
			return false;
		}

		let curDate = DateTime.utc().startOf('month');
		if (_d.valueOf() > curDate.valueOf()) {
			return false;
		}

		return true;
	},
	checked: v => {
		return v == 1 || v === true;
	},
	partTime: v => {
		return v !== null && (typeof(v) === 'string' && v.length > 0 || typeof(v) === 'number') && (v == 1 || v == 0);
	},
	reducedWork: v => {
		return v !== null && (typeof(v) === 'string' && v.length > 0 || typeof(v) === 'number') && (v == 1 || v == 0);
	},
	eligibilityCode: v => {
		if (v === undefined || v === null) { return false; }
		if (v.length === 0) { return false; }
		if (v.length !== 11 || v.match(/[^\d]/)) { return false; }
		if (!checkCode(v)) { return false; }

		return true;
	},
};

app.directive('validate', [ '$rootScope', 'channel', '$timeout', function($rootScope, channel, $timeout) {
	return {
		scope: {
			id: '@', type: '@', required: '@', validate: '@', ngModel: '&',
			validateIgnoreKeys: '@',  // comma separated list of key codes to ignore validation on the given event occurence
			validateTab: '@',  // boolean type, if set on element, tab keyup is validated, otherwise tab is ignored in triggering validation, as tab is used for navigation around the form
			validateName: '@',  // used for channel messages
		},
		controllerAs: 'ctrl', restrict: 'A',
		controller: function($scope, $transclude) {
			var _this = this;
			_this.meta = { element: null, value: undefined, validation: undefined, parent: undefined };

			// attributes are meta values and shouldn't be confused with scope variables
			_this.setAttribute = function(attr, value) {
				_this.meta[attr] = value;
			};

			_this.toggleHighlight = function(_bool) {
				if (_bool === false && _this.meta.element.get(0).classList.contains('highlight-input')) {
					_this.meta.element.get(0).classList.remove('highlight-input');
				} else if (_bool === true) {
					_this.meta.element.get(0).classList.add('highlight-input');
				}
			};

			_this.getCurrentValue = function() {
				let domEl = _this.meta.element.get(0);
				if (domEl.nodeName.toLowerCase() !== 'select') {
					if (domEl.nodeName.toLowerCase() !== 'input' || domEl.getAttribute('type') !== 'checkbox') {
						_this.meta.value = domEl.value;
					} else {
						_this.meta.value = domEl.checked;
					}
				} else {
					let opt = domEl.options[domEl.selectedIndex];
					_this.meta.value = opt.value;
				}

				return _this.meta.value;
			};

			// does validation and returns empty string on valid, or string with message
			// boolean false if not valid but no string to return
			_this.validate = function() {
				_this.getCurrentValue();

				// fetch most recent value via angular, overwrites the getCurrentValue as that is the inline value
				if ($scope.ngModel() !== undefined) {
					_this.meta.value = $scope.ngModel();
				}

				if (_this.meta.value === undefined || _this.meta.value === null) {
					_this.meta.value = '';	// removing the content from the input makes the value undef for some odd reason
				}

				if ($scope.required && $scope.required == 'true' && _this.meta.value.length === 0) {
					return false;
				} else if (_this.meta.validation == false) {	// no checks, always return true
					return true;
				} else if (_this.meta.validation == true) {	// check by type
					switch ($scope.type) {
						case 'number':
							if (_this.meta.value.match(/\D/gi)) {
								return false;
							} else {
								return true;
							}
						break;
						case 'date':
							// We assume typical German format here: dd.mm.yyyy but we'll give some leeway
							var year, month, day;
								// 10-02-2018 | 10-02-18
							if (_this.meta.value.match(/^(\d{2})\D{1}(\d{2})\D{1}(\d{4}|\d{2})/)) {
								year = parseInt(RegExp.$3, 10);
								if (year.length == 2) { year += 2000; }
								month = parseInt(RegExp.$2);
								day = parseInt(RegExp.$1, 10);
								// 2018-10-10, no abbreviated year number since 18-10-19 is ambigous if non german format
							} else if (_this.meta.value.match(/^(\d{4}|\d{2})\D{1}(\d{2})\D{1}(\d{2})/)) {
								year = parseInt(RegExp.$1, 10);
								if (year.length == 2) { year += 2000; }
								month = parseInt(RegExp.$2);
								day = parseInt(RegExp.$3, 10);
							} else if (_this.meta.value.match(/^(\d+)(\.|) (\D+) (\d+)/i)) {
								year = parseInt(RegExp.$4, 10);
								if (year.length == 2) { year += 2000; }
								var dict = { 'jan': 0, 'januar': 0, 'feb': 1, 'februar': 1, 'märz': 2, 'maerz': 2,
											 'april': 3, 'mai': 4, 'jun': 5, 'juni': 5, 'jul': 6, 'juli': 6,
											 'aug': 7, 'august': 7, 'sep': 8, 'september': 8, 'okt': 9, 'oktober': 9,
											 'nov': 10, 'november': 10, 'dez': 11, 'dezember': 11 }
								month = parseInt(RegExp.$3, 10);
								if (dict[month.toLowerCase()] != undefined) { month = dict[month.toLowerCase()]; }
								else { month = -1; }
								day = parseInt(RegExp.$1, 10);
							} else {
								return false;
							}
							if (day < 0 || day > 31) {
								return false;
							} else if (month < 1 || month > 12) {
								return false;
							}

							if (DateTime.local(year, month, day).isValid) {
								return true;
							} else {
								return false;
							}
						break;

						default:
							return true;
					}
				} else if (typeof(_this.meta.validation) === 'function') {
					if (!_this.meta.validation(_this.meta.value)) {
						return false;
					} else {
						return true;
					}
				} else if (typeof(_this.meta.validation) === 'object') {
					if (_this.meta.validation.toString().match(/.+?object.+?/gi)) {	// JSON object
						if (_this.meta.validation.strlen !== undefined) {
							if (_this.meta.value.length === _this.meta.validation.strlen) {
								return true;
							} else {
								return false;
							}
						} else {
							//
						}
					} else {  // RegExp
						if (_this.meta.value.match(_this.meta.validation)) {
							return true;
						} else {
							return false;
						}
					}
				} else {
					//
				}
			};

			_this.triggerValidation = function() {
				let displayError = false;
				if (!_this.validate()) {
					_this.toggleHighlight(true);
					displayError = true;
				} else {
					_this.toggleHighlight(false);
				}

				// inline validation display within the controllers
				if ($scope.validateName && $scope.validateName.length) {
					channel.notify(`validation_${ $scope.validateName }`, {
						displayError
					});
				}
				// for promise based usage insice link function
				return displayError;
			};
		},
		link: function (scope, element, attrs, ctrl, $transclude) {
			ctrl.setAttribute('element', element);

			let event = scope.validate;
			let validateType = event;
			if (event.split(':').length > 1) {
				let _split = event.split(':');
				event = _split[0];
				validateType = _split[1];
			} else {
				event = 'blur';
			}
			if (validateType !== 'true' && validateType !== 'false' && typeof(validator[validateType]) !== 'undefined') {
				ctrl.setAttribute('validation', validator[validateType]);
			} else {
				ctrl.setAttribute('validation', true);
			}

			let domEl = element.get(0);
			let customUpdateEvent = domEl.getAttribute('validate-update-event') || '';
			if (customUpdateEvent) {
				channel.register(customUpdateEvent, data => {
					ctrl.setAttribute('value', data.value);
				});
			}

			// some keys are ignored by default, do not ignore all non-letter keys, as they might be needed, like insert, to trigger validation on inserting something
			let mapIgnoreKeys = {
				'16': 1,	// shift
				'17': 1,	// ctrl
				'18': 1,	// alt
				'20': 1,	// capslock
			};
			if (attrs.validateIgnoreKeys) {
				attrs.validateIgnoreKeys.split(',')
					  					.forEach(key => mapIgnoreKeys[key] = 1);
			}
			let customDelay = domEl.getAttribute('validate-delay') || 0;
			// we need to trigger the validation with a timeout, or for checkboxes we never receive checked=false inside _this.validate(),
			// while _this.triggerValidation() (what invokes validate()) has the correct value for some reason
			let validateTab = typeof(attrs.validateTab) !== 'undefined';
			$(element).on(event, function(e) {
				let k = e.keyCode || e.which;
				if (k === 0) {  // if no key - blur event, or any other event without key
					$timeout(() => ctrl.triggerValidation(e), customDelay);
				// Ignore all mapped keys, ignore tab by default, unless it is explicitely enabled
				} else if ((typeof(mapIgnoreKeys[k]) === 'undefined' && k !== 9) || (validateTab && k === 9) ) {
					$timeout(() => ctrl.triggerValidation(e), customDelay);
				}
			});

			// if we want to trigger the validation manually we can use this
			if (scope.validateName) {
				channel.register(`triggerValidationByName_${ scope.validateName }`, data => {
					return ctrl.triggerValidation();
				});
			}
		}
	};
}]);